// DEPENDENCIES
import React, { useState, useEffect, useCallback } from 'react';
// COMPONENTS
// ICONS
import { HiChevronRight } from 'react-icons/hi';
import { BiSearchAlt2 } from 'react-icons/bi';
// CUSTOM COMPONENTS
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
import ActionStrip from '../../../components/ActionStrip';
import InputBlock from '../../../components/InputBlock';
import Button from '../../../components/Button';
import { connect } from 'react-redux';

const JobListBlock = (props) => {
    const { jobs, setSelectedJobId, setSelectedJobNumber, auth } = props;
    const [allJobsVisible, setAllJobsVisible] = useState(false);
    const [jobsToShow, setJobsToShow] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (jobs.length > 0) {
            let userJobs = jobs.filter(x => x.isUserPartOfJob);

            if (userJobs.length === 0) {
                setSelectedJobId(jobs[0].id);
                setSelectedJobNumber(jobs[0].projectNumber)
                setAllJobsVisible(true);
            } else {
                setSelectedJobId(userJobs[0].id);
                setSelectedJobNumber(userJobs[0].projectNumber)
            }
            searchJobs();
        }
    }, [jobs])

    useEffect(() => {
        if (searchTerm) {
            searchJobs(jobs);
        }
    }, [searchTerm])

    const searchJobs = () => {
        let filtered = jobs.filter(x => x.projectNumber.includes(searchTerm));

        setJobsToShow(filtered)
    }

    return (
        <>
            <CustomBlock className="job-list-block-container h-100">
                <CustomBlock className="job-list-block-header">
                    <CustomBlock className="header-block">
                        <CustomBlock>
                            <ContentHeader
                                title="Jobs"
                                headerSize="sm"
                                textHeaderStyle="pb-0"
                            />
                        </CustomBlock>

                        <CustomBlock>
                            <Button
                                text={allJobsVisible ? "Show Only My Jobs" : "View All Jobs"}
                                className="primary--bg mr-0"
                                size="xxs"
                                onClick={() => setAllJobsVisible(!allJobsVisible)}
                            />
                        </CustomBlock>
                    </CustomBlock>

                    <CustomBlock className="search-block">
                        <InputBlock
                            placeholder="Search Job Numbers"
                            unpadded
                            onChange={(e) => setSearchTerm(e.target.value)}
                            iconLeft={
                                <BiSearchAlt2 size={20} className="grey--clr" />
                            }
                        />
                    </CustomBlock>
                </CustomBlock>

                <CustomBlock className="job-list-block">
                    {
                        !allJobsVisible && jobsToShow.filter(x => x.isUserPartOfJob).map((job, index) =>
                            <ActionStrip
                                key={job.id}
                                title={`#${job.projectNumber}`}
                                rightActionText="Details"
                                rightActionIcon={
                                    <HiChevronRight size={25} />
                                }
                                backgroundColor="lighter--bg"
                                // primaryOnClick={() => {
                                //     setSelectedJobId(job.id)
                                //     setSelectedJobNumber(job.projectNumber)
                                // }}
                                rightActionTo={"/services/manage-job/general-information/" + job.id}
                            />
                        )
                    }

                    {
                        allJobsVisible &&
                        jobsToShow.map((job, index) =>
                            <ActionStrip
                                key={job.id}
                                title={`#${job.projectNumber}`}
                                rightActionText="Details"
                                rightActionIcon={
                                    <HiChevronRight size={25} />
                                }
                                backgroundColor="lighter--bg"
                                // primaryOnClick={() => {
                                //     setSelectedJobId(job.id)
                                //     setSelectedJobNumber(job.projectNumber)
                                // }}
                                rightActionTo={"/services/manage-job/general-information/" + job.id}
                                highlighted={allJobsVisible && job.isUserPartOfJob}
                            />
                        )
                    }
                </CustomBlock>

            </CustomBlock>
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, null)(JobListBlock);